import { CashStatementsQuickFilter } from "../../containers/Quickfilters/CashStatementsQuickFilter/interfaces";
import { LegalEntityQuickFilter } from "../../containers/Quickfilters/LegalEntityQuickfilter/interfaces";
import { Page } from "../../models/api/page/page";
import { SaveResponse } from "../../models/api/save/save.response";
import { BankTransactionDTO } from "../../models/bank-transaction/bank-transaction-dto";
import { BankTransactionSTO } from "../../models/bank-transaction/bank-transaction-sto";
import { BankTransactionsFilter } from "../../models/bank-transaction/bank-transactions.filter";
import { SearchOptions } from "../../models/search-options/search-options";
import { toastifyResponse } from "../../utils/toastify-response/toastify-response";
import { BaseApiService } from "../base/base-api.service";

export class BankTransactionsApiService extends BaseApiService<BankTransactionDTO, BankTransactionSTO> {
  constructor() {
    super({
      servicePath: "/LegalEntityBankAccounts",
      loadItemsPath: "/GetBankTransactions",
      saveItemsPath: "/SaveBankTransactions",
    });
  }
}

export const loadLegalEntityBankTransactions = async (
  propsFilter: {
    cashStatements: CashStatementsQuickFilter["cashStatements"];
    legalEntities: LegalEntityQuickFilter["legalEntities"];
    year: number;
    withoutJustificationDoc: boolean;
    withoutTransactionLinks: boolean;
    forecastsOnly: boolean;
  },
  page: Page,
  searchOptions: SearchOptions,
  signal: AbortSignal
) => {
  const { query, exactMatch } = searchOptions;

  const response = await new BankTransactionsApiService().loadItems(
    {
      ids: [],
      isDeleted: false,
      createdByUsers: [],
      modifiedByUsers: [],
      legalEntityIds: [...propsFilter.legalEntities.legalEntityIds],
      bankAccountIds: [...propsFilter.cashStatements.cashStatementsIds],
      year: propsFilter.year,
      withoutJustificationDoc: propsFilter.withoutJustificationDoc,
      withoutTransactionLinks: propsFilter.withoutTransactionLinks,
      forecastsOnly: propsFilter.forecastsOnly,
    } as BankTransactionsFilter,
    query,
    [],
    page,
    exactMatch,
    60,
    signal
  );

  toastifyResponse(response, "failed");

  return response;
};

export const saveBankTransaction = async (
  transaction: BankTransactionSTO,
  onlyFailedMessage?: boolean
): Promise<SaveResponse> => {
  const response = await new BankTransactionsApiService().saveItems([transaction]);

  onlyFailedMessage
    ? toastifyResponse(response, "failed")
    : toastifyResponse(response, "all", "default_success_message", "default_cancellation_message", "error_saving_data");

  return response;
};

export const loadBankTransaction = async (id: string) => {
  const response = await new BankTransactionsApiService().loadItems({
    ids: [id],
  });

  toastifyResponse(response, "failed");

  return response;
};

export const saveBankTransactions = async (
  transactions: BankTransactionSTO[],
  onlyFailedMessage?: boolean
): Promise<SaveResponse> => {
  const response = await new BankTransactionsApiService().saveItems(transactions);

  onlyFailedMessage
    ? toastifyResponse(response, "failed")
    : toastifyResponse(response, "all", "default_success_message", "default_cancellation_message", "error_saving_data");

  return response;
};
